import { reactive } from 'vue'
import { Store } from 'vuex'
import { LangList, LangData } from '@/i18n/langType'
import { State as StoreState } from '@/store/index'
import { useStoreAction } from '@/model/store/store'
import * as log from '@/model/util/log/Logger'

// 状態
type LangState = {
  // 言語
  lang: string
  // 言語リスト
  list: Array<LangData>
}

/**
 * 画面の初期状態を取得する
 * @param store vuex
 * @returns reactiveした初期状態
 */
const useLang = (store: Store<StoreState>) => {
  const state = reactive<LangState>({
    lang: store.getters.language,
    list: LangList,
  })

  return state
}

/**
 * 言語切り替え
 * @param state 状態
 * @param store vuex
 */
const change = async (state: LangState, store: Store<StoreState>) => {
  // 言語の切り替えを実施
  log.debug(`lang change. lang:${state.lang}`)
  await useStoreAction(store).changeLang(state.lang)
}

export { useLang, change, LangState }
